<template>
    <div v-if="levelList.length>0" class="breadcrumb-list">
        <div v-for="(item,index)  in levelList" v-if="menuHeaderMap[item]" :key="index">
            <router-link :to="item">{{menuHeaderMap[item].title}}</router-link>
        </div>
        <!--<div>IOT终端/设备信息</div>-->
    </div>

    <!--<div v-if="levelList.length>1" class="d2-multiple-page-control-group" flex>
        <div class="d2-multiple-page-control-content" flex-box="1">
            <div class="d2-multiple-page-control-content-inner">
                &lt;!&ndash;<el-breadcrumb separator-class="el-icon-arrow-right" style="background: #ffffff;padding: 10px 20px;margin-left: 1px;border-bottom: 1px solid #eaeaea;">
                  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                  <el-breadcrumb-item>活动管理</el-breadcrumb-item>
                  <el-breadcrumb-item>活动列表</el-breadcrumb-item>
                  <el-breadcrumb-item>活动详情</el-breadcrumb-item>
                </el-breadcrumb>&ndash;&gt;
                <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
                    &lt;!&ndash;<transition-group name="breadcrumb">&ndash;&gt;
                    <el-breadcrumb-item v-for="(item,index)  in levelList" v-if="menuHeaderMap[item]" :key="index">
                        &lt;!&ndash;<span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{item.meta.title}}</span>
                        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>&ndash;&gt;
                        <router-link :to="item">{{menuHeaderMap[item].title}}</router-link>
                    </el-breadcrumb-item>
                    &lt;!&ndash;</transition-group>&ndash;&gt;
                </el-breadcrumb>
            </div>
        </div>

    </div>-->
</template>

<script>
    //import { mapState, mapMutations } from 'vuex'
    export default {
        name: 'ZebraBreadcrumbCaiot',
        components: {

        },
        props:{
            menuHeader: {
                type: Array,
                required: true
            },
            menuAside: {
                type: Array,
                required: true
            }
        },
        created() {
            this.menuHeaderMap = this.setMenuHeaderMap(this.menuAside)
            this.getBreadcrumb()
        },
        data () {
            return {
                levelList: null,
                menuHeaderMap: {},
                // 不显示面包屑的页面路径
                excludePath: [
                    '/index',
                    '/index/',
                    '/appstore-public/login',
                    '/appstore-public/register'
                ]
            }
        },
        /*computed: {
            ...mapState({
                menuHeader: state => state.d2admin.menuHeader,
                menuAside: state => state.d2admin.menuAside
            })
        },*/
        watch: {
            $route() {
                this.getBreadcrumb()
            },
            'menuHeader': function (val, oldVal) {
                console.log('顶栏菜单已改变：new: %s, old: %s', val, oldVal)
                this.menuHeaderMap = this.setMenuHeaderMap(val)
            }
        },
        methods: {
            getBreadcrumb() {
                /*let matched = this.$route.matched.filter(item => item.name)
                const first = matched[0]
                if (first && first.name !== 'index') {
                    matched = [{ path: '/index', meta: { title: '首页' }}].concat(matched)
                }
                this.levelList = matched*/
                let currentPath = this.$route.path
                if(this.excludePath.indexOf(currentPath)!=-1){
                    this.levelList = []
                }else{
                    let levelList = []
                    this.setLevelListPath(levelList,currentPath)
                    //增加首页链接
                    //levelList.splice(0,0,'/index')
                    this.levelList = levelList
                }
            },
            setLevelListPath(levelList,path){
                levelList.splice(0,0,path)
                if(this.menuHeaderMap[path] && this.menuHeaderMap[path].parentPath){
                    this.setLevelListPath(levelList,this.menuHeaderMap[path].parentPath)
                }
            },
            setMenuHeaderMap(menuHeader,parentPath){
                let menuHeaderMap = {}
                for(let i in menuHeader){
                    menuHeaderMap[menuHeader[i].path] = {
                        'title': menuHeader[i].title,
                        'parentPath': parentPath
                    }
                    if(menuHeader[i].children){
                        menuHeaderMap = {...menuHeaderMap,...this.setMenuHeaderMap(menuHeader[i].children,menuHeader[i].path)}
                    }
                }
                return menuHeaderMap
            }
        }
    }
</script>

<style lang="scss">
    .app-breadcrumb{
        background: #ffffff;
        padding: 10px 20px;
        border: 1px solid #e8e7e7;
        border-width: 0 0 1px 0;

        .el-breadcrumb__inner a{
            //color: #66b1ff;
            font-weight: normal;
        }
    }
</style>

<style lang="scss" scoped>
    .breadcrumb-list {
        padding: 20px 0 20px 6px;

        /*background: linear-gradient(225deg,transparent 30px,#06213899 0);
        border: 1px solid #123854;
        border-bottom: 0;*/
        //border-image: linear-gradient( #123854, #0a3956) 30 30;

        div a{
            color: rgb(0, 122, 169);
        }

        //height: 267px;
        div:first-child {
            a {
                font: 18px 'Source Han Sans CN Bold';
                color: rgb(0, 122, 169);
            }
            line-height: 1;
            //padding-top: 36px;
        }

        div:nth-child(2) {
            a {
                font: 28px 'Source Han Sans CN Bold';
                color: transparent;
            }
            line-height: 1;
            background-image: linear-gradient(to top, #0095ff, #00e5ff);
            -webkit-background-clip: text;
            //padding-top: 20px;
        }

        div:nth-child(3) {
            a {
                font: 40px 'Source Han Sans CN Bold';
                color: transparent;
            }
            line-height: 1;
            background-image: linear-gradient(to top, #0095ff, #00e5ff);
            -webkit-background-clip: text;
            padding-top: 20px;
        }

        /*div:last-child {
            padding-top: 56px;
        }*/
    }
</style>
